var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.375,
    height: 17.29,
    viewBox: "0 0 14.375 17.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4620",
    "data-name": "Path 4620",
    d: "M5.031-17.29H3.594a2.148,2.148,0,0,0-2.156,2.116V-2.237A2.156,2.156,0,0,0,3.594-.081L5.031,0A2.156,2.156,0,0,0,7.188-2.156V-15.094A2.191,2.191,0,0,0,5.031-17.29Zm-8.625,0H-5.031a2.156,2.156,0,0,0-2.156,2.156V-2.2A2.166,2.166,0,0,0-5.031,0h1.438A2.156,2.156,0,0,0-1.437-2.156V-15.094a2.191,2.191,0,0,0-2.156-2.2Z",
    transform: "translate(7.188 17.29)",
    fill: "#a2a2a2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.b35996fbb0644ebf2297ba3d1a80ff64.svg";
export { ForwardRef as ReactComponent };